import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

type TiledImageListRef = React.RefObject<Map<IWatermarkElement['uuid'], string>>;
const TiledImage = ({ el, tiledImages }: { el: IWatermarkElement; tiledImages: TiledImageListRef }) => {
  return (
    <img
      draggable={false}
      src={tiledImages.current.get(el.uuid)} // this is in a weak map, and depends on the render count increasing to update
      className={classNames(styles.tiledImage, { [styles.pulse]: el.settings.duration === 'pulse' })}
      style={
        {
          opacity: el.settings.image.opacity,
          '--rotate': `${el.settings.dimensions.rotation ?? 0}deg`,
        } as CSSProperties
      }
    />
  );
};

export default TiledImage;
